/* eslint-disable sonarjs/no-identical-functions */
import {
  BlockServiceWatcher,
  type ExtensionType,
} from '@blocksuite/affine/block-std';
import {
  AffineFormatBarWidget,
  AffineSlashMenuWidget,
  EdgelessRootBlockSpec,
  PageRootBlockSpec,
} from '@blocksuite/affine/blocks';

import { setupFormatBarAIEntry } from './entries/format-bar/setup-format-bar';
import { setupSlashMenuEntry } from './entries/slash-menu/setup-slash-menu';

class AIPageRootWatcher extends BlockServiceWatcher {
  static override readonly flavour = 'affine:page';

  override mounted() {
    super.mounted();
    this.blockService.specSlots.widgetConnected.on(view => {
      if (view.component instanceof AffineFormatBarWidget) {
        setupFormatBarAIEntry(view.component);
      }

      if (view.component instanceof AffineSlashMenuWidget) {
        setupSlashMenuEntry(view.component);
      }
    });
  }
}

export const AIPageRootBlockSpec: ExtensionType[] = [
  ...PageRootBlockSpec,
  AIPageRootWatcher,
];

class AIEdgelessRootWatcher extends BlockServiceWatcher {
  static override readonly flavour = 'affine:page';

  override mounted() {
    super.mounted();
    this.blockService.specSlots.widgetConnected.on(view => {
      if (view.component instanceof AffineFormatBarWidget) {
        setupFormatBarAIEntry(view.component);
      }

      if (view.component instanceof AffineSlashMenuWidget) {
        setupSlashMenuEntry(view.component);
      }
    });
  }
}

export const AIEdgelessRootBlockSpec: ExtensionType[] = [
  ...EdgelessRootBlockSpec,
  AIEdgelessRootWatcher,
];
